import { React, useEffect } from 'react'

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { style } from "../../style/style";


function Cookies(props) {

  return (
    <Grid container spacing={2} sx={style.staticPage}>
      <Paper style={style.staticPage}>
        <Grid container>

          <Grid item xs={12}>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              textAlign="left"
              spacing={0}
              sx={{
                "& p": {
                  fontSize: "16px",
                  lineHeight: 1.7,
                  margin: "0 0 12px",
                  color: "#222"
                },
                "& strong": {
                  fontWeight: 700,
                  color: "#111"
                },
                "& h1": {
                  fontSize: "36px",
                  lineHeight: 1.2,
                  margin: "0 0 20px",
                  fontWeight: 700
                },
                "& h2": {
                  fontSize: "26px",
                  lineHeight: 1.3,
                  margin: "28px 0 12px",
                  fontWeight: 700
                },
                "& h3": {
                  fontSize: "20px",
                  lineHeight: 1.4,
                  margin: "20px 0 10px",
                  fontWeight: 700
                },
                "& ul": {
                  paddingLeft: "20px",
                  margin: "0 0 12px",
                },
                "& li": {
                  marginBottom: "10px",
                  fontSize: "16px",
                },
                ".tableWrapper": {
                  overflowX: "scroll",
                  width: "100%",
                },
                "table": {
                  border: "1px solid #ccc",
                  borderCollapse: "collapse",
                  width: "100%",
                  marginBottom: "20px",
                },
                "table th": {
                  border: "1px solid #ccc",
                  padding: "8px",
                  backgroundColor: "#f5f5f5",
                  fontSize: "16px",
                },
                "table td": {
                  border: "1px solid #ccc",
                  padding: "8px",
                  fontSize: "16px",
                }
              }}
            >

              <h1>Integrar Privacy Policy</h1>
              <p>Integrar respects your privacy and is committed to protecting your personal data. In the course of our acting for you, we may receive information relating to you, as an individual or as director, shareholder, partner, employee or representative of a company or organisation. This Privacy Policy sets out the basis on which we will process this personal data.</p>

                <p><b>Who we are</b></p>

                <p>Integrar is a trading name of Knights
                Professional Services Limited. We are a company registered in England and Wales
                under company number 08453370 and our registered office is at The Brampton,
                Newcastle-under-Lyme, Staffordshire ST5 0QW. We act as either a data
                controller or data processor depending on the nature of the services we
                provide.</p>

                <p>We act as a data controller where we determine the purposes and means of processing your personal data. This will
                usually be the case where we provide legal or professional services directly to you. We act as a data processor where we process your personal data on behalf of another
                organisation (such as a mortgage lender, broker, or financial institution) in accordance with their instructions. This will usually be the case where we
                provide legal or professional services to a lender, broker or other intermediary,
                in which case, that organisation will be the data controller, and you should
                also refer to their privacy notice for further information about how your
                personal data is used.</p>

                <p>Although we are not obliged by law to
                appoint a Data Protection Officer, we have appointed a Data Privacy Manager
                (DPM) who is responsible for overseeing questions in relation to this Privacy
                Policy. If you have any questions about this Privacy Policy, including any
                requests to exercise your legal rights, please contact the DPM using the
                details set out below.</p>

                <p><strong>Our contact details</strong></p>

                <p>Full name of legal entity: Knights Professional Services Limited.</p>

                <p>Our main trading address is also The Brampton, Newcastle-under-Lyme, Staffordshire ST5 0QW. Our vat registration number is 208 8271 04. </p>

                <p>Email address: <a href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a></p>

                <p>We are authorised and regulated by the Solicitors Regulatory Authority. Our SRA number is 620595.</p>

                <p>If you are based in the European Economic Area (EEA) and you have any questions about this Privacy Policy, including any requests to exercise your legal rights, you can contact our European Representative through the following channels:</p>

                <p>Postal address: The DPO Centre Europe Ltd, Alexandra House, 3 Ballsbridge Park, Dublin, D04C 7H2</p>

                <p>Phone number: +353 1 631 9460</p>

                <p>Email address: <a href="mailto:advice@dpocentre.com">advice@dpocentre.com</a></p>

                <p>You have the right to make a complaint at any time to the Information Commissioner's Office (ICO), which is the UK
                supervisory authority for data protection issues (www.ico.org.uk). Knights is
                registered with the ICO, registration number ZA112722. We would, however,
                appreciate the chance to deal with your concerns before you approach the ICO so
                please contact us in the first instance.</p>

                <h2>Changes to the Privacy Policy and your duty to inform us of changes</h2>

                <p>We may need to update this Privacy Policy
                from time to time. If the change is material, we will place a prominent notice
                on our website or update you by other appropriate means, contacting you at the
                details you have provided to us in your last correspondence.</p>

                <p>It is important that the personal data we
                hold about you is accurate and up to date. We may ask you to confirm updates to
                your personal data from time to time but please keep us informed if your
                personal data changes during your relationship with us in the meantime. Please
                inform the DPM of any changes in your data at the following email
                address: <a href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a></p>

                <h2>The data we collect about you</h2>

                <p>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the person's identity has been removed (Anonymous Data).</p>

                <p>We may collect, use, store and transfer
                different kinds of personal data as necessary to enable us to carry out your
                instructions, to manage and operate our business and to comply with our legal
                and regulatory obligations. We have grouped together the personal data into
                different types below:</p>

                <ul>

                  <li>Identity data
                  includes first name, maiden name, last name, username or similar identifier,
                  marital status, title, date of birth, gender and photographs, copies of
                  passport, national identity card, driving licence, utility bills, and other
                  similar documents.</li>

                  <li>Contact data includes postal address, email address and telephone numbers.</li>

                  <li>Professional data includes
                  academic qualifications and achievements, references, profession, job title,
                  employer and professional history of these things, immigration status and work
                  permits.</li>

                  <li>Welfare data includes grievance and disciplinary information, information relating to
                  criminal convictions and allegations of criminal activity, medical records and
                  information including dietary requirements and religious information.</li>

                  <li>Financial data includes bank account, payment card details and pension details.</li>

                  <li>Transaction data includes details about payments to and from you and other details of services
                  you have purchased from us.</li>

                  <li>Technical data includes internet protocol (IP) address, your login data, browser type and
                  version, time zone setting and location, browser plug-in types and versions,
                  operating system and platform and other technology on the devices you use to
                  access our website, data from building access controls, information we obtain
                  from our it and communications monitoring.</li>

                  <li>Profile data includes your username and password to any Knights online service, your
                  interests, preferences, feedback and survey responses.</li>

                  <li>Usage data includes information about how you use our website and services.</li>

                  <li>Marketing and communications data includes your preferences in receiving marketing from us and our third parties and your communication preferences.</li>

                  <li>Other personal data contained in correspondence and documents which you or others on your behalf or in connection with your matter may provide to us.</li>


                </ul>

                <h2>Special Category Data </h2>

                <p>We may collect Special Categories of
                Personal Data about you (this includes details about your race or ethnicity,
                religious or philosophical beliefs, sex life, sexual orientation, political
                opinions, trade union membership, information about your health and genetic and
                biometric data). Much of this information is provided by way ofWelfare
                Data. We may also collect information about criminal convictions and offences.
                Further legal controls apply to data relating to criminal convictions and
                allegations of criminal activity. All such information is collected in
                accordance with this Privacy Policy. We have in place appropriate policy
                documents and/or other safeguards which we are required by law to maintain when
                processing such data.</p>

                <p>We may also receive Special Categories of
                Personal Data about you from your bank, building society, mortgage broker,
                estate agent or financial advisor. In these circumstances, we rely on the
                data controller establishing a legal basis for processing your Special
                Categories of Personal Data and for sharing it with us. </p>

                <h2>Data relating to criminal convictions and offences</h2>

                <p>We may collect and store personal data relating to criminal convictions and offences (including the alleged
                commission of offences) only where necessary for the purposes of the prevention
                or detection of an unlawful act and is necessary for reasons of substantial
                public interest; providing or obtaining legal advice; and establishing,
                exercising or defending legal rights. </p>

                <h2>If you fail to provide personal data</h2>

                <p>Where we need to collect personal data by
                law, or under the terms of a contract we have with you and you fail to provide
                that data when requested, we may not be able to perform the contract we have,
                or are trying to enter into, with you (for example, to provide you with
                services). In this case, we may have to cancel a product or service you have
                with us but we will notify you if this is the case at the time.</p>

                <h2>How is your personal data collected?</h2>

                <p>We use different methods to collect data
                from and about you. You may give us your personal data by completing
                information on the Integrar Portal, filling in forms or by corresponding with
                us by post, phone, email or otherwise. This includes personal data you provide
                when you:</p>

                <ul>

                  <li> enter into a contract with us;</li>

                  <li> make a payment to us for events or services;</li>

                  <li> subscribe to our services or publications;</li>

                  <li> request marketing to be sent to you;</li>

                  <li> attend a networking event;</li>

                  <li> complete a survey; and</li>

                  <li> provide us with feedback.</li>

                </ul>

                <p>We collect most of the personal data directly from you. However, we also collect and process personal data about you which we
                have received from:</p>

                <ul>

                  <li> third parties, such as your mortgage lender, bank, building society, mortgage broker, estate agent
                  or financial advisor in order to provide remortgage services;</li>

                  <li> third parties where they are a party to or otherwise concerned in a matter on which we are acting
                  for you;</li>

                  <li> public sources, such as Companies House, Land Registry, the Electoral Register, 192.com, DueDil and
                  MarketIQ;</li>

                  <li> analytics providers or search information providers as a result of visiting our website; and</li>

                  <li> our IT systems, such as practice management systems or building access controls and reception logs.</li>

                </ul>

                <h2>Automated technologies or interactions</h2>


                <p>As you interact with our website and portal, we may automatically collectTechnical Data about your equipment,
                browsing actions and patterns. We collect this personal data by using cookies,
                server logs and other similar technologies. We may also receive Technical Data
                about you if you visit other websites or portals employing our cookies. Please see our <a href="/cookies">Customer Portal Cookie policy for further details.</a></p>

                <h2>How we use your personal data</h2>

                <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>

                <ul>

                  <li> where we need to perform the contract we are about to enter into or have entered into with you or our clients;</li>

                  <li> where it is necessary for our legitimate interests (or those of a third party) and your
                  interests and fundamental rights do not override those interests;</li>

                  <li> where we need to comply with a legal or regulatory obligation; and</li>

                  <li> where this is
                  necessary to protect your vital interests, or someone else's vital interests
                  this is typically in an emergency.</li>

                </ul>

                <p>Generally, we do not rely on consent as a
                legal basis for processing your personal data other than we may send third
                party direct marketing communications to you by email or text message. You have
                the right to withdraw consent to marketing at any time by contacting us
                at <a href="mailto:customerservicesmanager@integrar.services">
                customerservicesmanager@integrar.services</a>.</p>

                <h2>Purposes for which we will use your personal data</h2>

                <p>Set out in the table below is a description
                of all the ways we plan to use your personal data, and the legal basis upon
                which we rely to do so. Where it is appropriate, we have also identified what
                our legitimate interests are.</p>

                <blockquote>
                  <p>Where we rely on <b>legitimate interests</b> as a basis for using your personal data, we have carried out an
                  assessment to ensure that we have weighed your interests, rights and freedoms
                  and any risk posed to you against our own interests, ensuring that they are
                  proportionate and appropriate. If you wish further information about this
                  assessment, please contact our DPM at <a href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a>.
                  There may be more than one legal basis for us processing your data depending on the specific
                  particular purpose for which we are doing so. Please contact us at <a
                  href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a> if you need details about the specific legal basis upon which we are relying to
                  process your personal data where more than one ground is set out inthe
                  table below. </p>
                </blockquote>


                <div className="tableWrapper">
                <table>
                  <tr style={{ backgroundColor: '#f5f5f5' }}>
                    <th><strong>Purpose for which we will process the information</strong></th>
                    <th><strong>Lawful Basis for processing including basis of legitimate interest</strong></th>
                    <th><strong>Third party processing</strong></th>
                  </tr>
                  <tr>
                    <td>Registering you on our website and portal</td>
                    <td>For the performance of a contract with you; on the basis of your consent</td>
                    <td>Third party IT, practice management systems, and communications service providers</td>
                  </tr>
                  <tr>
                    <td>Providing services to mortgage lender clients</td>
                    <td>On the basis of your consent; necessary to provide our service to mortgage lender clients to assist in remortgage; client has established a legal basis for processing personal data</td>
                    <td>Third party IT, practice management systems, online data room hosting providers, and communications service providers</td>
                  </tr>
                  <tr>
                    <td>To provide legal professional services to you in connection with your matters</td>
                    <td>For the performance of our contracts with you or to take steps at your request before entering into a contract</td>
                    <td>Third party IT, practice management systems, online data room hosting providers, and communications service providers</td>
                  </tr>
                  <tr>
                    <td>To carry out associated administration and accounting in relation with your matters, including: (a) carry out credit reference checks (b) manage payments, fees and charges (c) collect and recover money owed to us (d) provide catering</td>
                    <td>To comply with professional, legal and regulatory obligations; For our legitimate interests (to carry out credit control and to ensure that our clients are likely to be able to pay for our services as well as recover debts due to us). We consider this use to be proportionate and not prejudicial or detrimental to you; It is in our legitimate interests to provide catering to you and to provide dietary requirements (to develop and grow our business and for your safety). We consider this use to be proportionate and not prejudicial or detrimental to you; On the basis of your consent.</td>
                    <td>Third party accounting systems, practice management systems payroll and marketing preference management service providers; Third party catering companies</td>
                  </tr>
                  <tr>
                    <td>To manage our relationship with you which will include: (a) Complying with our internal business policies and procedures (b) Updating client records (c) Notifying you about changes to our terms or privacy policy (d) Asking you to leave a review, provide feedback or take a survey</td>
                    <td>For the performance of our contract with you or to take steps at your request before entering into a contract; To comply with our legal and regulatory obligations; For our legitimate interests (to keep our records updated and to study how customers use our services)</td>
                    <td>Third party practice management and communication service providers</td>
                  </tr>
                  <tr>
                    <td>To market our services to you, including: (a) provide updates or newsletters (b) invite you to events or functions (c) make suggestions and recommendations to you about services that may be of interest to you</td>
                    <td>It is in our legitimate interests to market our services (to develop our services and grow our business). We consider this use to be proportionate and not prejudicial or detrimental to you.</td>
                    <td>Third party marketing preferences managers, data analysers and communication service providers</td>
                  </tr>
                  <tr>
                    <td>To administer and protect our business and this website (including troubleshooting, data analysis, testing, system maintenance, support, reporting and hosting of data)</td>
                    <td>It is in our legitimate interests (for running our business, provision of administration and it services, network security, to prevent fraud and in the context of a business reorganisation or group restructuring exercise). We consider this use to be proportionate and not prejudicial or detrimental to you; To comply with a legal obligation.</td>
                    <td>Third party IT, hosting, archive, practice management, communications, payroll and marketing preference management service providers</td>
                  </tr>
                  <tr>
                    <td>To deliver relevant website content and advertisements to you and measure or understand the effectiveness of the advertising we serve to you</td>
                    <td>It is necessary for our legitimate interests (to study how clients use our services, to develop them, to grow our business and to inform our marketing strategy). We consider this use to be proportionate and not prejudicial or detrimental to you.</td>
                    <td>Third party IT, communications and marketing preference management service providers</td>
                  </tr>
                  <tr>
                    <td>To use data analytics to improve our website, services, marketing, client relationships and experiences</td>
                    <td>It is necessary for our legitimate interests (to define types of users of our events and services, to keep our website updated and relevant, to develop our organisation).</td>
                    <td>Third party IT, data analytics and marketing preference management service providers</td>
                  </tr>
                </table>
              </div>

                <h3>Marketing</h3>

                <p>Integrar strives to provide you with choices
                regarding certain personal data uses, particularly around marketing and advertising.
                We have established the following personal data control mechanisms:</p>

                <ul>

                  <li> we may use your
                  Identity, Contact, Technical, Usage and Profile Data to form a view on what we
                  think you may want or need, or what may be of interest to you;</li>

                  <li> you will receive
                  marketing communications from us if you have requested information from us, or
                  purchased services from us and, in each case, you have not opted out of
                  receiving that marketing;</li>

                  <li> for email marketing
                  to an individual subscriber (i.e. a non-corporate email address) with whom we
                  have no pre-existing relationship, we will need your consent to send you
                  unsolicited email marketing;</li>

                  <li> we will get your
                  express opt-in consent before we share your personal data with any company
                  outside the Knights Group for marketing purposes; and</li>

                  <li> where you provide
                  consent, you can ask us - or third parties - to stop sending you marketing
                  messages at any time by unsubscribing or updating your preferences below;
                  following the opt-out links on any marketing message sent to you; or contacting
                  our DPM (<a href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a>) at any time.
                  Please note that where you opt out of receiving these marketing messages, this
                  will not apply to personal data provided to us as a result of a service
                  purchase or other transactions.</li>

                </ul>

                <h3>Cookies</h3>

                <p>You can set your browser to refuse
                some, or all, browser cookies, or to alert you when websites or portals set or
                access cookies. If you disable or refuse cookies, please note that some parts
                of our website or portal may become inaccessible or not function properly. For
                more information about how to manage the use of cookies, please see our <a href="/cookies">Customer Portal Cookie policy</a></p>

                <h3>Change of purpose</h3>

                <p>We will only use your personal data for the
                purposes for which we collected it, unless we reasonably consider that we need
                to use it for another reason and that reason is compatible with the original
                purpose. If you would like an explanation as to how the processing for the new
                purpose is compatible with the original purpose, please contact us at <a
                href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a>. If we need to use
                your personal data for an unrelated purpose, we will notify you and we will
                explain the legal basis which allows us to do so.</p>

                <p>Please note that we may process your
                personal data without your knowledge or consent, in compliance with the above
                rules, where this is required or permitted by law.</p>

                <h2>Disclosures of your personal data</h2>

                <p>We do not share or disclose any of your personal
                information without your consent, other than for the purposes specified in this
                Privacy Policy; where there is a legal requirement; or it is necessary in order
                to protect the vital interests of a person. We may have to share your personal
                data with the parties set out below for the purposes set out in the table
                above.</p>

                <p><strong>Internal Third Parties</strong> as set out in the Glossary below</p>

                <p><strong>External Third Parties</strong> as set out in the Glossary below.</p>

                <p>We require all third parties to respect the
                security and confidentiality of your personal data and to treat it in
                accordance with the law. We do not allow our third-party service providers to
                use your personal data for their own purposes and only permit them to process
                your personal data for specified purposes and in accordance with our
                instructions.</p>

                <h2>International transfers</h2>

                <p>Some of our External Third Parties
                are based outside the UK so their processing of your personal data will involve
                a transfer of data outside the UK.</p>

                <p>Whenever we transfer your personal data out of the UK, we ensure a similar degree of protection is afforded to it
                by applying at least one of the following safeguards:</p>

                <ul>
                <li>We will only transfer your
                    personal data to countries that have been deemed to provide an adequate
                    level of protection for personal data.</li>
                <li>Where we use certain service
                    providers, we may use specific contracts approved for use in the UK which
                    give your personal data the same protection it has in the UK.</li>
                </ul>

                <p>Please contact us at <a href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a> if you would like further information on the specific
                mechanism used by us when transferring your personal data out of the UK. </p>

                <h2>Data security</h2>

                <p>We have appropriate security measures in
                place to prevent your personal data from being accidentally lost, used or
                accessed in an unauthorised way, altered or disclosed. In addition, we limit
                access to your personal data to those employees, agents, contractors and other
                third parties who have a business need to know. They will only process your
                personal data on our instructions and they are subject to a duty of
                confidentiality.</p>

                <p>Integrar cannot guarantee the security of
                information transmitted over the internet or that unauthorised persons will not
                obtain access to personal data. We have put in place procedures to deal with
                any suspected personal data breach and will notify you and any applicable
                regulator of a breach.</p>

                <h2>Data retention</h2>

                <p>We will only retain your personal data for
                as long as is necessary to fulfil the purpose(s) for which we collected and
                processed it, including for the purposes of satisfying any legal, accounting,
                or reporting requirements.</p>

                <p>In determining the appropriate retention
                period for personal data, we consider the amount, nature, and sensitivity of
                the personal data, the potential risk of harm from unauthorised use or
                disclosure of your personal data, the purposes for which we process your
                personal data and whether we can achieve those purposes through other means,
                and the applicable legal requirements.</p>

                <p>Details of retention periods for different
                aspects of your personal data are available in our retention policy a copy of
                which you can request from us by contacting us at <a href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a>, Due to legal and
                regulatory requirements, we may need to retain personal data for up to seven
                years after we cease providing services and products to you, where necessary,
                to comply with our legal obligations, resolve disputes or enforce our terms and
                conditions.</p>

                <p>In some circumstances, you can ask us to
                delete your data: see request erasure of your personal data below for further
                information.</p>

                <p>In some circumstances, we may anonymise your
                personal data (so that it can no longer be associated with you) for research or
                statistical purposes in which case we may use this information indefinitely
                without further notice to you.</p>

                <h2>Data complaints</h2>

                <p>If you have any concerns about how we
                collect, use or otherwise handle your personal data, you have the right to
                raise a complaint with us at any time. You can do this by emailing us at <a
                href="mailto:customerservicesmanager@integrar.services">customerservicesmanager@integrar.services</a> with a brief
                explanation of why you are dissatisfied with our use of your personal data. We
                may need to ask to see copies of identification documents, such as a driving
                licence or passport, in order to help us confirm your identity. We will
                acknowledge your complaint within one month of receipt and let you know when
                you should expect to receive a response from us. You also have the right to
                lodge a complaint with the Information Commissioner's Office (ICO), the UK
                supervisory authority for data protection matters. Further information on how
                to contact the ICO is available at www.ico.org.uk. We would, however,
                appreciate the opportunity to address your concerns before you approach the
                ICO.</p>

                <h2>Your legal rights</h2>

                <p>Under certain circumstances, you have rights
                under data protection laws in relation to your personal data. You have the
                right to:</p>

                <p><strong>Request access</strong> to your personal
                data (commonly known as a <b>subject access request</b>). This enables you to
                receive a copy of the personal data we hold about you and to check that we are
                processing it lawfully.</p>

                <p><strong>Request correction</strong> of the personal data
                that we hold about you. This enables you to have any incomplete or inaccurate
                data we hold about you corrected, though we may need to verify the accuracy of
                the new data you provide to us.</p>

                <p><strong>Request erasure</strong> of your personal
                data. You may ask us to delete or remove personal data where there is no good
                reason for us continuing to process it. You also have the right to ask us to
                delete or remove your personal data where you have successfully exercised your
                right to object to processing (see below), where we may have processed your
                information unlawfully or where we are required to erase your personal data to
                comply with local law. There may be specific legal reasons why we cannot comply
                with your request of erasure. If there are, we will notify you at the time of
                your request.</p>

                <p><strong>Object to processing</strong> of your personal
                data where we are relying on a legitimate interest (or those of a third party)
                and there is something about your particular situation which makes you want to
                object to processing on this ground as you feel it impacts on your fundamental rights
                and freedoms. You also have the right to object where we are processing your
                personal data for direct marketing purposes. In some cases, we may demonstrate
                that we have compelling legitimate grounds to process your information which
                override your rights and freedoms.</p>

                <p><strong>Request restriction of processing</strong> of your personal
                data. This enables you to ask us to suspend the processing of your personal
                data in the following scenarios: (a) if you want us to establish the accuracy
                of the data; (b) where our use of the data is unlawful but you do not want us
                to erase it; (c) where you need us to hold the data even if we no longer
                require it as you need it to establish, exercise or defend legal claims; or (d)
                you have objected to our use of your data but we need to verify whether we have
                overriding legitimate grounds to use it.</p>

                <p><strong>Request the transfer</strong> of your personal
                data to you or to a third party. We will provide to you, or a third party you
                have chosen, your personal data in a structured, commonly used,
                machine-readable format. This right only applies to automated information for
                which you initially provided consent to us to use or where we used the
                information to perform a contract with you.</p>

                <p><strong>Withdraw consent at any time</strong> where we are relying
                on consent to process your personal data. However, this will not affect the
                lawfulness of any processing carried out before you withdraw your consent. If
                you withdraw your consent, we may not be able to provide certain products or services
                to you. We will advise you if this is the case at the time you withdraw your
                consent.</p>

                <p><strong>No fee usually required</strong></p>

                <p>You will not have to pay a fee to access
                your personal data (or to exercise any of the other rights). However, we may
                charge a reasonable fee if your request is clearly unfounded, repetitive or
                excessive. Alternatively, we may refuse to comply with your request in these
                circumstances.</p>

                <p><strong>What we may require from you</strong></p>

                <p>We may need to request specific information
                from you to help us confirm your identity and ensure your right to access your
                personal data (or to exercise any of your other rights). This is a security
                measure to ensure that personal data is not disclosed to any person who has no
                right to receive it. We may also contact you to ask you for further information
                about your request so that we may speed up our response.</p>

                <p><strong>Time limit to respond</strong></p>

                <p>We try to respond to all legitimate requests
                within one month. Occasionally, it may take us longer than a month if your
                request is particularly complex or you have made a number of requests. In this
                case, we will notify you and keep you updated.</p>

                <h2>Glossary</h2>

                <p><strong>Legitimate Interest</strong> means the
                interest of our business in conducting and managing our business to enable us
                to give you the best service/product and the best and most secure experience.
                We make sure that we consider and balance any potential impact on you (both
                positive and negative) and your rights before we process your personal data for
                our legitimate interests. We do not use your personal data for activities where
                our interests are overridden by the impact on you (unless we have your consent
                or are otherwise required or permitted to by law). You can obtain further
                information about how we assess our legitimate interests against any potential
                impact on you in respect of specific activities by contacting us at <a href="mailto:customerservicesmanager@integrar.services">
                customerservicesmanager@integrar.services</a>.</p>

                <p><strong>Performance of Contract</strong> means
                processing your data where it is necessary for the performance of a contract to
                which you are a party or to take steps at your request before entering into
                such a contract.</p>

                <p><strong>Comply with a legal or regulatory obligation</strong> means
                processing your personal data where it is necessary for compliance with a legal
                or regulatory obligation that we are subject to.</p>

                <p><b>The Knights Group means Knights Group Holdings plc</b> which includes Knights Professional Services Limited and any of
                its current direct or indirect subsidiaries and/or controlled affiliates as
                well as any successors to Knights Professional Services Limited and any of its
                direct or indirect subsidiaries and/or controlled affiliates.</p>

                <p><strong>Internal Third Parties means:</strong></p>

                <ul>
                  <li> Knights Group partners, staff and consultants based in the UK.</li>
                  <li> Other companies in the Knights Group</li>
                </ul>

                  <p><b>External Third Parties means:</b></p>


              <ul>

                  <li> Mortgage lender,
                  bank, building society, mortgage broker, estate agent or financial advisor who
                  we provide services to and who share with us personal data relating to their
                  customers in order for us to perform our contact, provide services to them and
                  provide remortgage services to their customers. </li>

                  <li> Service providers
                  acting as processors who provide IT, online data room hosting or website and
                  system administration services.</li>

                  <li> Suppliers based in the
                  UK providing marketing services to us, or with whom we are conducting joint
                  marketing exercises.</li>

                  <li> Professional
                  advisers acting as processors or joint controllers including lawyers, bankers,
                  auditors and insurers who provide consultancy, banking, legal, insurance,
                  pension and accounting services.</li>

                  <li> Our professional
                  indemnity insurers or brokers, and our auditors, or risk managers who we or
                  they may appoint.</li>

                  <li> HM Revenue &amp;
                  Customs, regulators and other authorities acting as processors or joint
                  controllers based in the UK who require reporting of processing activities in
                  certain circumstances.</li>

                  <li> Public authorities
                  or education providers acting as processors or joint controllers based in the
                  UK who provide confirmation of qualifications or educational achievements.</li>

                  <li> Third parties to
                  whom we choose to sell, transfer, or merge parts of our business or our assets.
                  Alternatively, we may seek to acquire other businesses or merge with them. If a
                  change happens to our business, then the new owners may use your personal data
                  in the same way as set out in this privacy notice.</li>

                  <li> Any other disclosure
                  which we, acting in good faith, consider disclosure to be required by law or
                  the rules of any applicable governmental, regulatory or professional body.</li>

                </ul>
              
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default Cookies
